import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiHome, FiUsers, FiBriefcase, FiHeart, FiCamera } from 'react-icons/fi';

// Master list of occasion landings. Each item maps to a route + an icon.
const ALL_OCCASIONS = [
  {
    to: '/family-weekend-getaway-lonavala',
    title: 'Family Weekend Getaways',
    desc: 'Multi-gen family trips with kid-safe pools and dedicated caretakers.',
    icon: FiUsers,
  },
  {
    to: '/intimate-celebrations-lonavala',
    title: 'Intimate Celebrations',
    desc: 'Birthdays, anniversaries, pre-wedding sangeet, baby showers.',
    icon: FiHeart,
  },
  {
    to: '/corporate',
    title: 'Corporate Retreats',
    desc: 'Offsites, leadership workshops and team-building for 20–48.',
    icon: FiBriefcase,
  },
  {
    to: '/shooting',
    title: 'Film & TV Shoots',
    desc: 'Cinematic backdrops, private lawns and reliable production support.',
    icon: FiCamera,
  },
];

/**
 * Internal-linking block shown at the bottom of every "occasion" landing page.
 * Lists all OTHER occasions (excludes the current page) so visitors can hop
 * across without going back to the homepage.
 */
const OtherOccasions = ({ currentPath = '', heading = 'Also Perfect For' }) => {
  const others = ALL_OCCASIONS.filter((o) => o.to !== currentPath);

  return (
    <section data-testid="other-occasions-section" className="py-14 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-10">
          <p className="text-[#F57C20] text-[10px] font-semibold tracking-[0.2em] uppercase mb-2">More Ways to Stay</p>
          <h2 className="text-2xl md:text-3xl font-light text-[#1A1A2E]" style={{ fontFamily: "'Playfair Display', serif" }}>
            {heading}
          </h2>
        </div>
        <div className={`grid grid-cols-1 sm:grid-cols-2 ${others.length >= 3 ? 'lg:grid-cols-3' : 'lg:grid-cols-2'} gap-5`}>
          {others.map((o) => (
            <Link
              key={o.to}
              to={o.to}
              data-testid={`other-occasion-${o.to.replace(/\W+/g, '-')}`}
              className="block bg-[#F7F8FA] rounded-xl p-6 border border-gray-100 hover:border-[#F57C20] hover:bg-white transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="bg-[#F57C20]/10 rounded-lg p-2.5 flex-shrink-0">
                  <o.icon className="w-5 h-5 text-[#F57C20]" />
                </div>
                <div className="min-w-0">
                  <h3 className="text-[#1A1A2E] text-base font-semibold mb-1.5">{o.title}</h3>
                  <p className="text-[#6B7280] text-xs leading-relaxed mb-3">{o.desc}</p>
                  <span className="text-[#F57C20] text-xs font-semibold inline-flex items-center gap-1">
                    Explore <FiArrowRight className="w-3 h-3" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/"
            data-testid="other-occasions-home-link"
            className="inline-flex items-center gap-2 text-[#1A1A2E] text-sm font-semibold hover:text-[#F57C20] transition-colors"
          >
            <FiHome className="w-4 h-4" /> View all occasions on the homepage
          </Link>
        </div>
      </div>
    </section>
  );
};

export default OtherOccasions;
